import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
import { useProgramacion } from "../hooks/useProgramacion";
import axios from "axios";
import { useColor } from "../hooks/useColor";

export const ProgramacionList = ({
  data,
  onDelete,
  onEditingClick,
  onAssignedClik,
}) => {
  const { deleteProgramacion } = useProgramacion();
  const { color } = useColor();

  const handleEliminar = (id) => {
    Swal.fire({
      icon: "warning",
      title: "¿Está seguro que desea continuar?",
      text: "Los registros eliminados no se podran recuperar",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "green",
      cancelButtonColor: "red",
      showLoaderOnConfirm: true,
      backdrop: true,
      preConfirm: async () => {
        try {
          await deleteProgramacion(id);
        } catch (error) {
          if (axios.isAxiosError(error)) {
            if (error.response.status === 400) {
              Swal.showValidationMessage(`
                Request failed: ${error.response.data.detail}
              `);
              return;
            }
          }
          Swal.showValidationMessage(`
            Request failed: ${error}
          `);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((res) => {
      if (res.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: "Registro eliminado",
          timer: 1500,
        });
        onDelete();
      }
    });
  };

  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr style={{ fontSize: "12px" }}>
            <th>Variedad</th>
            <th>Color</th>
            <th>Calibre</th>
            <th>Og/cv</th>
            <th>Etiqueta</th>
            <th>Peso</th>
            <th>Envase</th>
            <th>Cantidad</th>
            <th>Estiba</th>
            <th>Yegueres</th>
            <th>Fumigar</th>
            <th>Pais</th>
            <th>Destino</th>
            <th>Tarima</th>
            <th>Observaciones</th>
            <th>Asignado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item) => (
            <tr key={item.id} style={{ fontSize: "12px" }}>
              <td>{item.variedad}</td>
              <td>{color.find((col) => col.id === item.color)?.color ?? ""}</td>
              <td>{item.calibre}</td>
              <td>{item.og_cv}</td>
              <td>{item.etiqueta}</td>
              <td>{item.peso}</td>
              <td>{item.envase}</td>
              <td>{item.cantidad}</td>
              <td>{item.estiba}</td>
              <td>{item.yeguere}</td>
              <td>{item.fumigar}</td>
              <td>{item.pais}</td>
              <td>{item.destino}</td>
              <td>{item.tarima}</td>
              <td>{item.observaciones}</td>
              <td style={{ textAlign: "center" }}>
                {item.asignado === 1 ? (
                  <FontAwesomeIcon
                    icon="fas fa-check-circle"
                    size="xl"
                    style={{ color: "#63E6BE" }}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon="fas fa-times-circle"
                    size="xl"
                    style={{ color: "#ff4242" }}
                  />
                )}
              </td>
              <td>
                {item.asignado === 0 && (
                  <>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => onEditingClick(item.id)}
                    >
                      <FontAwesomeIcon icon="fas fa-pencil-alt" />
                    </button>{" "}
                    <button
                      className="btn btn-sm btn-outline-dark"
                      onClick={() => onAssignedClik(item)}
                    >
                      <FontAwesomeIcon icon="fas fa-plus-circle" />
                    </button>{" "}
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => handleEliminar(item.id)}
                    >
                      <FontAwesomeIcon icon="fas fa-trash-alt" />
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
